/**
 * Convert birth date from German UI format (DD.MM.YYYY) to API format (YYYY-MM-DD).
 * Cognito and the GraphQL backend expect ISO dates.
 */
export function toApiBirthDate(value) {
  if (value == null || value === '') return value;

  const trimmed = String(value).trim();

  const german = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(trimmed);
  if (german) {
    const [, day, month, year] = german;
    return `${year}-${month}-${day}`;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    return trimmed;
  }

  return value;
}

/** Parse birth date from API (YYYY-MM-DD) or legacy German (DD.MM.YYYY). */
export function parseBirthDate(value) {
  if (value == null || value === '') return null;

  const trimmed = String(value).trim();

  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed);
  if (iso) {
    const year = Number(iso[1]);
    const month = Number(iso[2]) - 1;
    const day = Number(iso[3]);
    const date = new Date(year, month, day);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const german = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(trimmed);
  if (german) {
    const day = Number(german[1]);
    const month = Number(german[2]) - 1;
    const year = Number(german[3]);
    const date = new Date(year, month, day);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  return null;
}

/** Value for `<input type="date">` (always YYYY-MM-DD). */
export function toHtmlDateInputValue(value) {
  if (value == null || value === '') return '';
  return toApiBirthDate(value);
}
